import { PaymentsOutput, PaymentsInput } from "@/interfaces/payments";
import { BaseService } from "./BaseService";

export class PaymentsService extends BaseService<
  PaymentsInput,
  PaymentsOutput
> {
  constructor() {
    super();
    this.path = "payments";
  }
}
